import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  questions: [],
  answers: [],
  currentQuestionIndex: 0,
  gScore: null,
  etsTraitScores: null,
  isSubmitted: false,
};

const etsQuizSlice = createSlice({
  name: 'etsQuiz',
  initialState,
  reducers: {
    setETSQuizQuestions: (state, action) => {
      state.questions = action.payload;
      state.answers = Array(action.payload.length).fill(null);
      state.currentQuestionIndex = 0;
      state.isSubmitted = false;
      state.gScore = null;
      state.etsTraitScores = null;
    },
    selectETSAnswer: (state, action) => {
      const { questionId, selectedValue } = action.payload;
      const index = state.questions.findIndex(q => q._id === questionId);
      if (index !== -1) {
        state.answers[index] = { questionId, selectedValue };
      }
    },
    goToNextETSQuestion: (state) => {
      if (state.currentQuestionIndex < state.questions.length - 1) {
        state.currentQuestionIndex++;
      }
    },
    goToPreviousETSQuestion: (state) => {
      if (state.currentQuestionIndex > 0) {
        state.currentQuestionIndex--;
      }
    },
    goToSpecificETSQuestion: (state, action) => {
      const index = action.payload;
      if (index >= 0 && index < state.questions.length) {
        state.currentQuestionIndex = index;
      }
    },
    setETSQuizResults: (state, action) => {
      const { gScore, etsTraitScores } = action.payload;
      state.gScore = gScore;
      state.etsTraitScores = etsTraitScores;
      state.isSubmitted = true;
    },
    resetETSQuizState: (state) => {
      Object.assign(state, initialState);
    },
  }
});

export const {
  setETSQuizQuestions,
  selectETSAnswer,
  goToNextETSQuestion,
  goToPreviousETSQuestion,
  goToSpecificETSQuestion,
  setETSQuizResults,
  resetETSQuizState,
} = etsQuizSlice.actions;

export default etsQuizSlice.reducer;